// Keyboard/button semantics for clickable non-button elements (e.g. MUI Box cards).
export function activateOnKey(onActivate) {
  return event => {
    if (event.target !== event.currentTarget) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onActivate(event);
    }
  };
}

export function buttonSemantics(onActivate, extra = {}) {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: activateOnKey(onActivate),
    ...extra,
  };
}
